import { useQuery } from "@tanstack/react-query";

import { partJsonQuery } from "#modules/parts/infra/partJson.query";

export const usePartJson = (id: string | undefined) => {
  const { data, ...rest } = useQuery({ ...partJsonQuery(id) });

  return { partJson: data ?? null, ...rest };
};
